// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoriesStyles } from "@conklin/App/Widgets/FeaturedCategories/FeaturedCategories";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

featuredCategoriesStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        column-gap: 22px;
        row-gap: 32px;
        padding: 0 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr);
            padding: 0;
        }
    `,
};

featuredCategoriesStyles.centeringWrapper = {
    css: css`
        display: flex;
        height: 100px;
        justify-content: center;
        align-items: center;
    `,
};

featuredCategoriesStyles.mainTitle = {
    variant: "h2",
    css: css`
        padding: 0 16px;
    `,
};
